/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TrophyV5, TrophyV5Interface } from "../TrophyV5";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetIsNFT",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetOperators",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "getProperty",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "idRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tournamentID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "gladiatorID",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "properties",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "value",
            type: "bytes32",
          },
        ],
        internalType: "struct EnumerableMap.MapEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60c06040526754726f706879563560c01b6080523480156200002057600080fd5b5060405162001656380380620016568339810160408190526200004391620001a9565b6001600160601b0319606082901b1660a052620000817f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a63362000095565b6200008e60003362000095565b50620001d9565b620000a18282620000a5565b5050565b600082815260208181526040909120620000ca918390620009be6200011e821b17901c565b15620000a157620000da6200013e565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b600062000135836001600160a01b03841662000142565b90505b92915050565b3390565b600062000150838362000191565b620001885750815460018181018455600084815260208082209093018490558454848252828601909352604090209190915562000138565b50600062000138565b60009081526001919091016020526040902054151590565b600060208284031215620001bb578081fd5b81516001600160a01b0381168114620001d2578182fd5b9392505050565b60805160a05160601c6114386200021e600039806104a1528061063e52806106f052806107b35250806104d1528061066b528061071f528061081a52506114386000f3fe608060405234801561001057600080fd5b50600436106100fb5760003560e01c8062ad800c14610100578063177c89eb14610129578063248a9ca31461013e5780632b42e5551461015e5780632f2ff15d1461017357806336568abe146101885780634a5dc3aa1461019b5780634f558e79146101ae578063502a581f146101c157806371a97305146101d75780638f12c2f4146101ec5780639010d07c146101f457806391d1485414610207578063a217fddf1461021a578063c9230c5d14610222578063ca15c8731461022a578063cdc2cfe21461023d578063d539139314610250578063d547741f14610258578063f7b108081461026b575b600080fd5b61011361010e3660046110cf565b61028b565b60405161012091906112aa565b60405180910390f35b61013161032c565b6040516101209190611291565b61015161014c3660046110cf565b610331565b60405161012091906111a1565b610166610346565b60405161012091906111f5565b6101866101813660046110e7565b610396565b005b6101866101963660046110e7565b6103fd565b6101516101a9366004610f69565b61045e565b6101316101bc3660046110cf565b610624565b6101c96106eb565b60405161012092919061129c565b6101df6107b1565b60405161012091906111aa565b6101516107d5565b6101df610202366004611112565b6107dc565b6101316102153660046110e7565b6107fb565b610151610813565b610151610818565b6101516102383660046110cf565b61083c565b61015161024b366004611112565b610853565b610151610876565b6101866102663660046110e7565b610888565b61027e6102793660046110cf565b6108e1565b6040516101209190611242565b60008181526001602081815260409283902080548451600294821615610100026000190190911693909304601f8101839004830284018301909452838352606093909183018282801561031f5780601f106102f45761010080835404028352916020019161031f565b820191906000526020600020905b81548152906001019060200180831161030257829003601f168201915b505050505090505b919050565b600190565b60009081526020819052604090206002015490565b60408051600180825281830190925260609182919060208083019080368337019050509050308160008151811061037957fe5b6001600160a01b0390921660209283029190910190910152905090565b6000828152602081905260409020600201546103b4906102156109d3565b6103ef5760405162461bcd60e51b815260040180806020018281038252602f815260200180611333602f913960400191505060405180910390fd5b6103f982826109d7565b5050565b6104056109d3565b6001600160a01b0316816001600160a01b0316146104545760405162461bcd60e51b815260040180806020018281038252602f8152602001806113d4602f913960400191505060405180910390fd5b6103f98282610a40565b60006104786000805160206113b4833981519152336107fb565b61049d5760405162461bcd60e51b8152600401610494906112bd565b60405180910390fd5b60607f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663de26648a877f000000000000000000000000000000000000000000000000000000000000000060018760405160200161050391906111a1565b6040516020818303038152906040526040518563ffffffff1660e01b815260040161053194939291906111be565b600060405180830381600087803b15801561054b57600080fd5b505af115801561055f573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610587919081019061100f565b905060008160008151811061059857fe5b602090810291909101810151600081815260018352604090208851919350916105c59183918a0190610e9a565b50600181016105e4816b1d1bdd5c9b985b595b9d125160a21b89610aa9565b506105fe816a19db18591a585d1bdc925160aa1b88610aa9565b50610616816818dc99585d1959105d60ba1b42610aa9565b509198975050505050505050565b604051635cb3163560e01b81526000906001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690635cb3163590610695907f000000000000000000000000000000000000000000000000000000000000000090869060040161129c565b60206040518083038186803b1580156106ad57600080fd5b505afa1580156106c1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106e591906110af565b92915050565b6000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316634af74fb07f00000000000000000000000000000000000000000000000000000000000000006040518263ffffffff1660e01b815260040161075a91906111a1565b604080518083038186803b15801561077157600080fd5b505afa158015610785573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107a99190611133565b915091509091565b7f000000000000000000000000000000000000000000000000000000000000000081565b6210000090565b60008281526020819052604081206107f49083610b42565b9392505050565b60008281526020819052604081206107f49083610b4e565b600081565b7f000000000000000000000000000000000000000000000000000000000000000090565b60008181526020819052604081206106e590610b63565b600082815260016020819052604082200161086e8184610b6e565b949350505050565b6000805160206113b483398151915281565b6000828152602081905260409020600201546108a6906102156109d3565b6104545760405162461bcd60e51b81526004018080602001828103825260308152602001806113626030913960400191505060405180910390fd5b6000818152600160208190526040822060609291019061090082610bb0565b90506060816001600160401b038111801561091a57600080fd5b5060405190808252806020026020018201604052801561095457816020015b610941610f26565b8152602001906001900390816109395790505b50905060005b828110156109b55760008061096f8684610bb4565b915091508184848151811061098057fe5b602002602001015160000181815250508084848151811061099d57fe5b6020908102919091018101510152505060010161095a565b50949350505050565b60006107f4836001600160a01b038416610c2f565b3390565b60008281526020819052604090206109ef90826109be565b156103f9576109fc6109d3565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000828152602081905260409020610a589082610c79565b156103f957610a656109d3565b6001600160a01b0316816001600160a01b0316837ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b60405160405180910390a45050565b600082815260018401602052604081205480610b0e5750506040805180820182528381526020808201848152865460018181018955600089815284812095516002909302909501918255915190820155865486845281880190925292909120556107f4565b82856000016001830381548110610b2157fe5b90600052602060002090600202016001018190555060009150509392505050565b60006107f48383610c8e565b60006107f4836001600160a01b038416610cf2565b60006106e582610bb0565b60006107f483836040518060400160405280601e81526020017f456e756d657261626c654d61703a206e6f6e6578697374656e74206b65790000815250610d0a565b5490565b815460009081908310610bf85760405162461bcd60e51b81526004018080602001828103825260228152602001806113926022913960400191505060405180910390fd5b6000846000018481548110610c0957fe5b906000526020600020906002020190508060000154816001015492509250509250929050565b6000610c3b8383610cf2565b610c71575081546001818101845560008481526020808220909301849055845484825282860190935260409020919091556106e5565b5060006106e5565b60006107f4836001600160a01b038416610dd4565b81546000908210610cd05760405162461bcd60e51b81526004018080602001828103825260228152602001806113116022913960400191505060405180910390fd5b826000018281548110610cdf57fe5b9060005260206000200154905092915050565b60009081526001919091016020526040902054151590565b60008281526001840160205260408120548281610da55760405162461bcd60e51b81526004018080602001828103825283818151815260200191508051906020019080838360005b83811015610d6a578181015183820152602001610d52565b50505050905090810190601f168015610d975780820380516001836020036101000a031916815260200191505b509250505060405180910390fd5b50846000016001820381548110610db857fe5b9060005260206000209060020201600101549150509392505050565b60008181526001830160205260408120548015610e905783546000198083019190810190600090879083908110610e0757fe5b9060005260206000200154905080876000018481548110610e2457fe5b600091825260208083209091019290925582815260018981019092526040902090840190558654879080610e5457fe5b600190038181906000526020600020016000905590558660010160008781526020019081526020016000206000905560019450505050506106e5565b60009150506106e5565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282610ed05760008555610f16565b82601f10610ee957805160ff1916838001178555610f16565b82800160010185558215610f16579182015b82811115610f16578251825591602001919060010190610efb565b50610f22929150610f3d565b5090565b604080518082019091526000808252602082015290565b5b80821115610f225760008155600101610f3e565b80356001600160a01b038116811461032757600080fd5b60008060008060808587031215610f7e578384fd5b610f8785610f52565b93506020858101356001600160401b0380821115610fa3578586fd5b818801915088601f830112610fb6578586fd5b813581811115610fc257fe5b610fd4601f8201601f191685016112ed565b91508082528984828501011115610fe9578687fd5b808484018584013781019092019490945293969395505050506040820135916060013590565b60006020808385031215611021578182fd5b82516001600160401b0380821115611037578384fd5b818501915085601f83011261104a578384fd5b81518181111561105657fe5b83810291506110668483016112ed565b8181528481019084860184860187018a1015611080578788fd5b8795505b838610156110a2578051835260019590950194918601918601611084565b5098975050505050505050565b6000602082840312156110c0578081fd5b815180151581146107f4578182fd5b6000602082840312156110e0578081fd5b5035919050565b600080604083850312156110f9578182fd5b8235915061110960208401610f52565b90509250929050565b60008060408385031215611124578182fd5b50508035926020909101359150565b60008060408385031215611145578182fd5b505080516020909101519092909150565b60008151808452815b8181101561117b5760208185018101518683018201520161115f565b8181111561118c5782602083870101525b50601f01601f19169290920160200192915050565b90815260200190565b6001600160a01b0391909116815260200190565b600060018060a01b0386168252846020830152836040830152608060608301526111eb6080830184611156565b9695505050505050565b6020808252825182820181905260009190848201906040850190845b818110156112365783516001600160a01b031683529284019291840191600101611211565b50909695505050505050565b602080825282518282018190526000919060409081850190868401855b828110156112845781518051855286015186850152928401929085019060010161125f565b5091979650505050505050565b901515815260200190565b918252602082015260400190565b6000602082526107f46020830184611156565b60208082526016908201527521b0b63632b91034b9903737ba10309036b4b73a32b960511b604082015260600190565b6040518181016001600160401b038111828210171561130857fe5b60405291905056fe456e756d657261626c655365743a20696e646578206f7574206f6620626f756e6473416363657373436f6e74726f6c3a2073656e646572206d75737420626520616e2061646d696e20746f206772616e74416363657373436f6e74726f6c3a2073656e646572206d75737420626520616e2061646d696e20746f207265766f6b65456e756d657261626c654d61703a20696e646578206f7574206f6620626f756e64739f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a6416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636520726f6c657320666f722073656c66a264697066735822122030ecf41b6310995607016f0fd9a9f4854ff48980dca3a99692e388b0a390af9864736f6c63430007040033";

export class TrophyV5__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TrophyV5> {
    return super.deploy(assetsAddress, overrides || {}) as Promise<TrophyV5>;
  }
  getDeployTransaction(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsAddress, overrides || {});
  }
  attach(address: string): TrophyV5 {
    return super.attach(address) as TrophyV5;
  }
  connect(signer: Signer): TrophyV5__factory {
    return super.connect(signer) as TrophyV5__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TrophyV5Interface {
    return new utils.Interface(_abi) as TrophyV5Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TrophyV5 {
    return new Contract(address, _abi, signerOrProvider) as TrophyV5;
  }
}
